
import PlanSingle from "./single";
import { CheckCircleIcon } from 'vue-feather-icons'
import LockIcon from "~/components/ui/icon/LockIcon.vue";
import PaypalLogo from "~/components/ui/icon/LogoPaypal.vue";
import StripeLogo from "~/components/ui/icon/LogoStripe.vue";
import ConversionMinutesHintDialog from "./ConversionMinutesHintDialog.vue";
import MoneyBackGuaranteeDialog from "./MoneyBackGuaranteeDialog.vue";

export default {
    name: "PlansIndex",
    components: { PlanSingle, CheckCircleIcon, LockIcon, PaypalLogo, StripeLogo, ConversionMinutesHintDialog, MoneyBackGuaranteeDialog },
    props: ["plans", 'selectedType', 'subscriptions'],
    data: () => ({
        activeSubscriptions: {},
        planEligibility: null,
        showLegacyAlert: false,
        couponApplied: false,
        discountAmount: 0,
    }),
    watch: {
        freeMember(val) {
            if (!val) {
                // don't apply coupon for pro users
                this.couponApplied = false;
                this.discountAmount = 0;
            }
        },
        /**
         * Processes subscriptions to update active subscriptions and eligibility details.
         * @param {Array} val - List of subscription objects.
         */
        subscriptions(val) {
            if (!(Array.isArray(val) && val.length)) return;
            this.planEligibility = {};
            val.forEach((sub) => {
                if (sub.plan.type === "unified-subscription") {
                    if (sub.status === "active") {
                        this.activeSubscriptions[sub.plan.id] = sub.pricingInfo;
                        this.planEligibility[sub.plan.id] = { ...sub.pricingInfo, msg: "currently_subscribed" };
                    } else if (sub.status === "pending") {
                        this.planEligibility[sub.plan.id] = { ...sub.pricingInfo, msg: "pending_subscription" };
                    }
                }
            });
        }
    },
    mounted() {
        this.initiatePlans()
    },
    computed: {
        freeMember() {
            return (
                !this.$store.state.subscription.loaded ||
                this.$store.state.subscription.name === undefined ||
                this.$store.state.subscription.name === "Free"
            );
        },
        activePlans() {
            return this.plans.map((planGroup) => {
                if (!planGroup || !Array.isArray(planGroup)) {
                    return null; // Handle undefined or invalid planGroup
                }
                if (planGroup.length > 1) {
                    return planGroup.find((item) => item.type === "unified-subscription") || planGroup[0];
                }
                return planGroup[0] || null; // Handle an empty array
            });
        },
    },
    methods: {
        /**
         * Initializes discount plans and handles coupon application with WisePops integration.
         */
        initiatePlans() {
            setTimeout(() => {
                const cookies = $nuxt.$cookies;
                const isCouponApplied = cookies.get("applied_coupon") || cookies.get("applied_coupon_from_email");
                const isProUser = cookies.get("pro_user");
                this.couponApplied = isCouponApplied && !isProUser && this.freeMember;
                this.discountAmount = this.couponApplied ? Number(cookies.get("coupon_discount_percentage")) : 0;
            }, 2000);

            this.$bus.$on("WISEPOPS_LOADED", () => {
                if (process.browser && window.wisepops) {
                    wisepops("listen", "after-popup-close", (event) => {
                        event.preventDefault();
                        if ($nuxt.$cookies.get("applied_coupon") && !$nuxt.$cookies.get("pro_user")) {
                            this.couponApplied = true;
                            this.discountAmount = Number($nuxt.$cookies.get("coupon_discount_percentage"));
                            const props = this.$cookies.get("wisepops_props") || {};
                            this.$cookies.remove("wisepops_props");
                            wisepops("properties", { ...props, couponApplied: true });
                            wisepops("pageview");
                        }
                    });
                }
            });
        },
        viewConversionMinuteHint() { this.$refs.ConversionMinutesHintDialog.open() },
        viewMoneyBackHint() { this.$refs.MoneyBackGuaranteeDialog.open() }
    },
};
